/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum SyncXeroInvoiceResult {
  Created = "Created",
  Relinked = "Relinked",
  AlreadyLinked = "AlreadyLinked",
}

export function instanceOfSyncXeroInvoiceResult(value: any): boolean {
  for (const key in SyncXeroInvoiceResult) {
    if (Object.prototype.hasOwnProperty.call(SyncXeroInvoiceResult, key)) {
      if (
        SyncXeroInvoiceResult[key as keyof typeof SyncXeroInvoiceResult] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function SyncXeroInvoiceResultFromJSON(
  json: any,
): SyncXeroInvoiceResult {
  return SyncXeroInvoiceResultFromJSONTyped(json, false);
}

export function SyncXeroInvoiceResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SyncXeroInvoiceResult {
  return json as SyncXeroInvoiceResult;
}

export function SyncXeroInvoiceResultToJSON(
  value?: SyncXeroInvoiceResult | null,
): any {
  return value as any;
}

export function SyncXeroInvoiceResultToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): SyncXeroInvoiceResult {
  return value as SyncXeroInvoiceResult;
}
